import { start } from '../../src';

void start({ apiUrl: __B2B_API_URL__ });
